module.exports = __webpack_public_path__ + "ada9042de76462b9336779240fc4c338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-event-banner.jpg
// module id = 204
// module chunks = 0